import {NavLink as ReactRouteNavLink} from 'react-router-dom';
import {useUsers} from "@flexinet/users-components";
import config from "../../../../config";
import {
    DashboardWidgetBuilder,
    WidgetDataPoint,
    WidgetType
} from "@flexinet/ui-components";

export const UsersWidget = () => {

    const {
        items,
    } = useUsers()


    const dataPoints: WidgetDataPoint[] = [];
    dataPoints.push({
                        value: items.length,
                        label: 'Users',
                        color: 'flexinet',
                    });


    const widget: WidgetType = {
        header: {
            title: 'Users',
        },
        body: {
            dataPoints: dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View All',
                    description:
                        'View All Users',
                    component: {ReactRouteNavLink},
                    // FNP-2017: user management lives in Flexi Directory.
                    to: `${config.platform.directory}/users`,
                    visible: true
                },
                {
                    label: 'Onboard User',
                    description:
                        'Onboard new user',
                    component: {ReactRouteNavLink},
                    // Directory adds a person from the New User drawer on its
                    // list, and has no /users/add page.
                    to: `${config.platform.directory}/users`,
                    visible: true,
                },
            ],
        }
    };

    return <DashboardWidgetBuilder widget={widget}/>;
};
